import type {FC} from 'react';
import {checkPathForPopup} from '../../../services/checkPathForPopup';
import {AcEmailConfirmNotice} from '../../AcEmailConfirmNotice';
import {EmailConfirmNotice} from '../../EmailConfirmNotice';
import {Popup} from '../Popup';
import {EngineerMobileHeader} from './EngineerMobileHeader';
import {EngineerPcHeader} from './EngineerPcHeader';

type Props = {
  className?: string;
  scoutsCount: number;
  interestsCount: number;
};

export const EngineerHeaderPresentation: FC<Props> = ({
  className,
  scoutsCount,
  interestsCount,
}) => {
  return (
    <div className={className}>
      <div className="pc:hidden">
        <EngineerMobileHeader
          scoutsCount={scoutsCount}
          interestsCount={interestsCount}
        />
      </div>
      <div className="hidden pc:block">
        <EngineerPcHeader
          scoutsCount={scoutsCount}
          interestsCount={interestsCount}
        />
      </div>
      {checkPathForPopup() && (
        <>
          <EmailConfirmNotice />
          <AcEmailConfirmNotice />
          <Popup />
        </>
      )}
    </div>
  );
};
